/*
creditcard-formats

usage:
test a number against a list of regular expressions for most cardproviders.
this test do not include a numeric evalutation, like the luhntest.

return:
 Boolean

*/

const cardtypes = {
	Amex: {
		// 17 chars
		reg: '^3[47][0-9]{13}$',
		check: true
	},
	AustralianBankcard: {
		reg: '^5610-?[0-9]{4}-?[0-9]{4}-?[0-9]{4}$',
		check: true
	},
	BCGlobal: {
		reg: '^(6541|6556)[0-9]{12}$',
		check: true
	},
	CarteBlanche: {
		reg: '^389[0-9]{11}$',
		check: true
	},
	DinersClub: {
		reg: '^3(?:0[0-5]|[68][0-9])[0-9]{11}$',
		check: true
	},
	DiscoverCard: {
		reg: '^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$',
		check: true
	},
	InstaPayment: {
		reg: '^63[7-9][0-9]{13}$',
		check: true
	},
	JCB: {
		reg: '^(?:2131|1800|35[0-9]{3})[0-9]{11}$',
		check: true
	},
	KoreanLocal: {
		reg: '^9[0-9]{15}$',
		check: true
	},
	Laser: {
		reg: '^(6304|6706|6709|6771)[0-9]{12,15}$',
		check: true
	},
	Maestro: {
		reg: '^(?:5[0678][0-9][0-9]|6304|6390|67[0-9][0-9])[0-9]{8,15}$',
		check: true
	},
	Mastercard: {
		reg: '^5[1-5][0-9]{14}$',
		check: true
	},
	Solo: {
		reg: '^(6334|6767)[0-9]{12}|(6334|6767)[0-9]{14}|(6334|6767)[0-9]{15}$',
		check: true
	},
	Switch: {
		reg: '^(4903|4905|4911|4936|6333|6759)[0-9]{12}|(4903|4905|4911|4936|6333|6759)[0-9]{14}|(4903|4905|4911|4936|6333|6759)[0-9]{15}|564182[0-9]{10}|564182[0-9]{12}|564182[0-9]{13}|633110[0-9]{10}|633110[0-9]{12}|633110[0-9]{13}$',
		check: true
	},
	UnionPay: {
		reg: '^(62[0-9]{14,17})$',
		check: true
	},
	Visa: {
		reg: '^4[0-9]{12}(?:[0-9]{3})?$',
		check: true
	},
	VisaMaster: {
		reg: '^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14})$',
		check: true
	},
	Astropay: {
		reg: '^1[0-9]{1}[0-5]{1}[0-9]{13}$',
		check: true
	}
};

function checkForPatterns(cardtypesObj = {}, str = '') {
	/* loop through object, compare regexp to string, if the cardnumber validates to any of the specified patterns
	it is considered valid */
	const validations = [];
	let foundMatch = false;
	Object.keys(cardtypesObj).forEach(key => {
		if (cardtypesObj[key].check && cardtypesObj[key].reg) {
			/* compare string to regexp, if not valid type key into console */
			const pattern = new RegExp(cardtypesObj[key].reg);
			const valid = pattern.test(str);
			const info = valid ? key : false;
			foundMatch = valid || foundMatch;
			validations.push(info);
		}
	});
	/*
	// debug-script to print matches to a method
	validations.forEach((elm) => {
		if (elm) {
			console.log('match:', str, elm);
		}
	}); */
	return Boolean(foundMatch);
}

function hasCreditcardFormat(t) {
	const str = t && t.toString ? t.toString() : null;
	const validPattern = checkForPatterns(cardtypes, str);
	const valid = str && validPattern;
	return Boolean(valid);
}
function hasCreditcardFormatOfCardType(t, type) {
	const str = t && t.toString ? t.toString() : null;
	const matchFormat = new RegExp(cardtypes[type].reg).test(str);
	return Boolean(matchFormat);
}

export { hasCreditcardFormat, hasCreditcardFormatOfCardType };
